import React from "react";
import { ReactComponent as Arrow } from "../assets/about-line.svg";
import { ReactComponent as Stars } from "../assets/stars.svg";

const Works = () => {
  return (
    <section className='work-container' id='my-works'>
      <Arrow id='works-arrow' />
      <Stars id='works-stars' />
      <h3>My works</h3>
      <div className='work-grid-container'>
        <div className='work-grid'>
          <a
            href='https://www.figma.com/proto/pQWXmUfegoV3l6kra0riTL/Celsius-2k22?page-id=46%3A3&type=design&node-id=46-4&t=RQ9MSM8JP0aSquyW-0&scaling=min-zoom'
            rel='noopener noreferrer'
            target='_blank'>
            <img alt='' src='https://i.ibb.co/WzfkPSJ/Frame-13.png'></img>
            <div className='hover-text'>
              <div className='text'>
                The dark purple theme of the college fest website creates a
                sleek and sophisticated vibe, making it an attractive
                destination for students. The user experience is enhanced by the
                clear navigation and clean layout, allowing visitors to easily
                access information about events and performances. Overall, the
                website effectively captures the excitement and energy of the
                college fest, inviting students to get involved and make the
                most of the experience.
              </div>
            </div>
          </a>
        </div>
        <div className='work-grid'>
          <a
            href='https://www.figma.com/proto/hmhsnbj0F3uNhGq2qOavrv/Pills-app?page-id=0%3A1&type=design&node-id=15-893&t=gmJViwqVKp9vFVNV-0&scaling=scale-down&starting-point-node-id=5%3A37'
            rel='noopener noreferrer'
            target='_blank'>
            <img alt='' src='https://i.ibb.co/RhbNQYM/Frame-22.png'></img>
            <div className='hover-text'>
              <div className='text'>
                Pill App is a user-friendly medication management app designed
                for seniors. It offers timely notifications and alarms to ensure
                they never miss their pills. With a simple interface and
                reminders, it promotes medication adherence, keeping older
                individuals healthier and happier.
              </div>
            </div>
          </a>
        </div>
        <div className='work-grid'>
          <a
            href='https://www.figma.com/proto/aAS13c3b8b823LNtf1o6nX/ciem?page-id=0%3A1&type=design&node-id=52-900&t=AxKlbUfdfPRCSxb8-0&scaling=min-zoom&starting-point-node-id=616%3A2'
            rel='noopener noreferrer'
            target='_blank'>
            <img alt='' src='https://i.ibb.co/t8zwwwd/Frame-249.png'></img>
            <div className='hover-text'>
              <div className='text'>
                I designed my college website for engineering courses, focusing
                on user-friendly navigation, responsive design, and clear
                program information. I prioritized easy access to course
                details, faculty profiles, and admission requirements, creating
                an informative and visually appealing platform to attract
                prospective students and facilitate their decision-making
                process.
              </div>
            </div>
          </a>
        </div>
        <div className='work-grid'>
          <a
            href='https://www.figma.com/proto/W4M9JJjFbtSXza2gkYTHKX/GYM?page-id=0%3A1&type=design&node-id=78-2&t=geXjtMBKsUzcmFlv-0&scaling=min-zoom'
            rel='noopener noreferrer'
            target='_blank'>
            <img alt='' src='https://i.ibb.co/y6589CZ/Group-1962.png'></img>
            <div className='hover-text'>
              <div className='text'>
                The gym website offers a range of online courses to help users
                reach their fitness goals from the comfort of their own home.
                The user-friendly design makes it easy to browse and sign up for
                courses, with clear navigation and intuitive layout. The online
                courses feature high-quality videos and interactive elements,
                providing a dynamic and engaging learning experience for users.
              </div>
            </div>
          </a>
        </div>
        <div className='work-grid'>
          <a
            href='https://www.figma.com/proto/fMW55QrI0gRnYRVFqrMVjm/MindHeal?page-id=0%3A1&type=design&node-id=165-58&t=slamrsy5MkgJVJAc-0&scaling=scale-down&starting-point-node-id=60%3A408'
            rel='noopener noreferrer'
            target='_blank'>
            <img alt='' src='https://i.ibb.co/5B10Dkp/Frame-1887.png'></img>
            <div className='hover-text'>
              <div className='text'>
                The book seller website is designed to be user-friendly and
                intuitive, with a clean layout and easy navigation. Users can
                easily browse through categories and search for specific titles,
                and the website also features recommendations and reviews to
                help users discover new books. Overall, the website aims to
                provide a seamless shopping experience for book lovers.
              </div>
            </div>
          </a>
        </div>
        <div className='work-grid'>
          <a
            href='https://www.figma.com/proto/aAS13c3b8b823LNtf1o6nX/ciem?page-id=0%3A1&type=design&node-id=52-900&t=AxKlbUfdfPRCSxb8-0&scaling=min-zoom&starting-point-node-id=616%3A2'
            rel='noopener noreferrer'
            target='_blank'>
            <img alt='' src='https://i.ibb.co/vDqSCW2/Frame-5-7.png'></img>
            <div className='hover-text'>
              <div className='text'>
                The crypto selling website has a sleek and modern design, with a
                user-friendly interface that makes it easy for users to
                navigate. The website has been carefully crafted to provide a
                seamless experience for users looking to buy and sell various
                cryptocurrencies. The design is visually appealing and
                intuitive, making it easy for users to find what they need
                quickly and efficiently.
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};
export default Works;
